import { isTouchScreen } from '../../../styles'
import type { IconButtonProps } from '../IconButton'
import type { Tokens } from '../../../theming/types'

export default (config: {
  props: Pick<IconButtonProps, 'kind' | 'size'>
  tokens: Tokens
}) => {
  const { props, tokens } = config

  const iconButtonStyles = {
    brand: {
      color: tokens.iconColorInverse,
    },
    primary: {
      color: tokens.iconColorInverse,
    },
    secondary: {
      color: tokens.iconColorDefault,
    },
    tertiary: {
      backgroundColor: tokens.ctaIconBgColorTertiaryDefault,
      color: tokens.iconColorDefault,
    },
    danger: {
      backgroundColor: tokens.ctaIconBgColorTertiaryDefault,
      color: tokens.iconColorError,
    },
  }

  return {
    button: {
      default: {
        ...iconButtonStyles[props.kind!],
        position: 'relative',

        height: props.size === 'small' ? tokens.ctaSizeSm : tokens.ctaSizeMd,
        width: props.size === 'small' ? tokens.ctaSizeSm : tokens.ctaSizeMd,

        paddingBlock: 0,
        paddingInline: 0,

        ...(props.kind === 'danger' && {
          '&:hover': {
            color: tokens.iconColorInverse,
          },
          '&:active, &[aria-expanded="true"]': {
            color: tokens.iconColorInverse,
          },
          '&:disabled': {
            color: tokens.iconColorInverse,
          },
        }),

        [isTouchScreen]: {
          height: tokens.ctaSizeLg,
          width: tokens.ctaSizeLg,

          paddingInline: '3px',
        },
      },

      badge: {
        display: 'inline-flex',
        position: 'absolute',
        insetInlineEnd: 0,
        insetBlockStart: 0,
        transform: 'translateX(50%) translateY(-50%)',
      },
    },
  } as const
}
